var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3488 24.368C23.1609 23.9021 24.5 22.2575 24.5 20.3V7.7C24.5 5.3804 22.6196 3.5 20.3 3.5H7.7C5.3804 3.5 3.5 5.3804 3.5 7.7V20.3C3.5 22.2574 4.83908 23.9021 6.65116 24.368M21.3488 24.368C21.0136 24.4542 20.6621 24.5 20.3 24.5H7.7C7.33785 24.5 6.98641 24.4542 6.65116 24.368M21.3488 24.368C21.2784 20.3696 18.0152 17.15 14 17.15C9.98481 17.15 6.72159 20.3696 6.65116 24.368M17.15 10.85C17.15 9.1103 15.7397 7.7 14 7.7C12.2603 7.7 10.85 9.1103 10.85 10.85C10.85 12.5897 12.2603 14 14 14C15.7397 14 17.15 12.5897 17.15 10.85Z",
    stroke: "#B5B5B5",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.77c4d2da.svg";
export { ForwardRef as ReactComponent };